
export const getControls = () => {
  return {
    "controls": {
      "counterLength": "8",
      "adminPassword": "1",
      "assistantPassword": "1",
      "percentage": "40",
      "employees": [
        {
          "id": "a03afc0f-7110-1542-1e43-a4e3ccb20009",
          "name": "Employee 1"
        },
        {
          "id": "337c7e65-a72b-b27e-d43b-8ccea0b08706",
          "name": "Employee 2"
        },
        {
          "id": "260fe476-9030-136d-0eb9-541e973d4fdf",
          "name": "Employee 3"
        },
        {
          "id": "8578f6b2-d147-a413-b75e-7b241fb43206",
          "name": "Employee 4"
        },
        {
          "id": "9c099da2-3ed2-de6e-1997-603acf61df24",
          "name": "Employee 5"
        }
      ],
      "vehicles": [
        {
          "id": "62baef99-ae0c-914a-3ce0-7747cb387e73",
          "name": "vehicle 2"
        },
        {
          "id": "e2fb4dfa-cd2b-962d-0f11-15bd29d091a3",
          "name": "vehicle 1"
        },
        {
          "id": "c1c6252d-3177-4c72-4a4c-9fa7d404dd14",
          "name": "vehicle 3"
        },
        {
          "id": "bc86df19-d51f-7284-1f89-69a9de748860",
          "name": "vehicle 4"
        }
      ]
    },
    clients: [{
      "number": "01285464570",
      "info": "information about this clients",
      "id": "116a83f9-1eee-b315-6aa0-17acc9c8721d"
    },
    {
      "number": "01285464588",
      "info": "information about this clients",
      "id": "e4b7cf94-192c-625c-397c-a0b2cad16f36"
    },
    {
      "number": "01285464575",
      "info": "information about this clients",
      "id": "d6173325-876c-d92c-4476-80447401101f"
    },]
  }
}

export const setControls = (controls) => {}
export const getClientsData = (data) => {
  return {
    "clients": [
      {
        "number": "01285464588",
        "info": "information about this clients",
        "id": "e4b7cf94-192c-625c-397c-a0b2cad16f36"
      },
      {
        "number": "01285464575",
        "info": "information about this clients",
        "id": "d6173325-876c-d92c-4476-80447401101f"
      }]}
}
export const updateClientsData = (data) =>{}
export const startNewDay = (data) => {}
export const getAllData = () => {
  return {
    "employees-vehicles": [
      {
        "rounds": [
          {
            "numOfOrders": 11,
            "employerMoney": 54,
            "systemTotalPrice": 15,
            "employerInputPrice": "135",
            "startedAt": [
              14,
              27
            ],
            "workingHours": "1 : 2",
            "roundID": "d1314052-0f7aa-389d-cd7a-9d81ab0ge8c99",
            "date": "Tue Jan 17 2023 02:00:00 GMT+0200 (Eastern European Standard Time)",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43",
              "name": "Employee 1"
            }
          },
          {
            "numOfOrders": 101,
            "employerMoney": "102.00",
            "systemTotalPrice": 105,
            "employerInputPrice": 105,
            "startedAt": [
              14,
              27
            ],
            "workingHours": "1 : 2",
            "roundID": "d1314052-07aa-3s8f9d-cd7a-9d8f1ab0e8c99",
            "date": "2023-01-16T12:27:21.373Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43",
              "name": "Employee 1"
            }
          },
          {
            "numOfOrders": 21,
            "employerMoney": 40,
            "systemTotalPrice": 25,
            "employerInputPrice": "100",
            "startedAt": [
              14,
              27
            ],
            "workingHours": "1 : 2",
            "roundID": "d1314052-07aa-389d-cd7a-9d81ab0e8sc99",
            "date": "2023-01-16T12:27:21.373Z",
            "vehicle": {
              "name": "Vehicle v 2",
              "id": "62baef9"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-a4e3ccb20009",
              "name": "Employee 2"
            }
          }
        ],
        "expenses": [
          {
            "petrol": "22",
            "oil": "50",
            "repairs": "15",
            "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
          },
          {
            "petrol": "2",
            "oil": "20",
            "repairs": "5",
            "id": "62baef9"
          }
        ],
        "date": "2023-01-16T12:27:21.373Z",
        "id": "1"
      },
      {
        "rounds": [
          {
            "numOfOrders": 31,
            "employerMoney": "32.00",
            "systemTotalPrice": 35,
            "employerInputPrice": 35,
            "startedAt": [
              14,
              27
            ],
            "workingHours": "1 : 2",
            "roundID": "d1314052-07aa-389d-cd7a-9d81ab0e8kc99",
            "date": "2023-01-16T12:27:21.373Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-1542-1e43-a4e3ccb20009",
              "name": "Employee 3"
            }
          },
          {
            "numOfOrders": 41,
            "employerMoney": "42.00",
            "systemTotalPrice": 45,
            "employerInputPrice": 45,
            "startedAt": [
              14,
              27
            ],
            "workingHours": "1 : 2",
            "roundID": "d1314052-07aa-389d-cd7a-9dw81ab0e8c99",
            "date": "2023-01-16T12:27:21.373Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef9"
            },
            "employer": {
              "id": "7110-1542-1e43-a4e3ccb20009",
              "name": "Employee 4"
            }
          },
          {
            "numOfOrders": 131,
            "employerMoney": "132.00",
            "systemTotalPrice": 153,
            "employerInputPrice": 135,
            "startedAt": [
              14,
              27
            ],
            "workingHours": "1 : 2",
            "roundID": "d1314052-07aa-38f9d-cd7a-j9d81ab0e8c99",
            "date": "2023-01-16T12:27:21.373Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43",
              "name": "Employee 1"
            }
          }
        ],
        "expenses": [
          {
            "petrol": "2",
            "oil": "0",
            "repairs": "1",
            "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
          },
          {
            "petrol": "29",
            "oil": "2",
            "repairs": "5",
            "id": "62baef9"
          }
        ],
        "date": "2023-01-17T12:27:21.373Z",
        "id": 2
      },
      {
        "rounds": [
          {
            "numOfOrders": 1,
            "employerMoney": "2.00",
            "systemTotalPrice": 5,
            "employerInputPrice": 5,
            "startedAt": [
              14,
              27
            ],
            "workingHours": [
              "N",
              "a"
            ],
            "roundID": "d1314052-07aa-389d-cd7a-9d81ab0e8c99",
            "date": "2023-01-16T12:27:21.373Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43-a4e3ccb20009",
              "name": "Employee num1"
            }
          },
          {
            "numOfOrders": 1,
            "employerMoney": "2.00",
            "systemTotalPrice": 5,
            "employerInputPrice": 5,
            "startedAt": [
              14,
              32
            ],
            "workingHours": "0 : 0",
            "roundID": "2f44cddc-c3e9-2721-f12c-b21d39925c37",
            "date": "2023-01-16T12:32:23.501Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43-a4e3ccb20009",
              "name": "Employee a1"
            }
          },
          {
            "numOfOrders": 2,
            "employerMoney": "40.00",
            "systemTotalPrice": 80,
            "employerInputPrice": 100,
            "startedAt": [
              15,
              21
            ],
            "workingHours": "0 : 2",
            "roundID": "b48d6a55-0aae-fdd4-283e-3a2287cb0643",
            "date": "2023-01-17T13:21:59.902Z",
            "vehicle": {
              "name": "Vehicle 2",
              "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43-a4e3ccb20009",
              "name": "Employee a 1"
            }
          },
          {
            "numOfOrders": 1,
            "employerMoney": "2.40",
            "systemTotalPrice": 5,
            "employerInputPrice": 6,
            "startedAt": [
              14,
              30
            ],
            "workingHours": [
              "N",
              "a"
            ],
            "roundID": "6d19d7cb-fc73-1ce9-6803-40938e65744c",
            "date": "2023-01-16T12:30:02.529Z",
            "vehicle": {
              "name": "Vehicle 3",
              "id": "e2fb4dfa-cd2b-962d-0f11-15bd29d091a3"
            },
            "employer": {
              "id": "337c7e65-a72b-b27e-d43b-8ccea0b08706",
              "name": " Employee a2"
            }
          },
          {
            "numOfOrders": 1,
            "employerMoney": "7.20",
            "systemTotalPrice": 15,
            "employerInputPrice": 18,
            "startedAt": [
              15,
              22
            ],
            "workingHours": "0 : 2",
            "roundID": "19181a42-b9e0-300a-038a-fb385b5fd371",
            "date": "2023-01-17T13:22:04.670Z",
            "vehicle": {
              "name": "Vehicle 3",
              "id": "e2fb4dfa-cd2b-962d-0f11-15bd29d091a3"
            },
            "employer": {
              "id": "337c7e65-a72b-b27e-d43b-8ccea0b08706",
              "name": "Employee a 2"
            }
          },
          {
            "numOfOrders": 1,
            "employerMoney": 30.4,
            "systemTotalPrice": 40,
            "employerInputPrice": "76",
            "startedAt": [
              15,
              24
            ],
            "workingHours": "0 : 1",
            "roundID": "a5078959-175d-eb41-034e-1f0bf5591443",
            "date": "2023-01-17T13:24:22.232Z",
            "vehicle": {
              "name": "Vehicle a",
              "id": "bc86df19-d51f-7284-1f89-69a9de748860"
            },
            "employer": {
              "id": "a03afc0f-7110-1542-1e43-a4e3ccb20009",
              "name": " Employee a 1"
            }
          }
        ],
        "expenses": [
          {
            "petrol": "10",
            "oil": "7",
            "repairs": "9",
            "id": "62baef99-ae0c-914a-3ce0-7747cb387e73"
          },
          {
            "petrol": "5",
            "oil": "9",
            "repairs": "6",
            "id": "e2fb4dfa-cd2b-962d-0f11-15bd29d091a3"
          },
          {
            "petrol": "5",
            "oil": "1",
            "repairs": "14",
            "id": "bc86df19-d51f-7284-1f89-69a9de748860"
          }
        ],
        "date": "2023-01-17T13:57:14.835Z",
        "id": "59c0b555-dac8-6996-02b1-de5f63fe6c99"
      }
    ]
  }
}
export const setAllData = () => {}

//##########################################( Real )####################################################
// const API_URL = 'http://localhost:5550';

// const headers = {
//   Accept: "application/json",
// };

// export const getControls = () => 
//   fetch(`${API_URL}/controls`, { headers })
//   .then((res) => res.json())
//   .then((data) => data);

// export const setControls = (controls) =>
//   fetch(`${API_URL}/set-controls`, {
//     method: "POST",
//     headers: {
//       ...headers,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ controls }),
//   });

// export const getClientsData = () => 
//   fetch(`${API_URL}/get-clients-data`, { headers })
//   .then((res) => res.json())
//   .then((data) => data);
  
// export const updateClientsData = (data) =>
//   fetch(`${API_URL}/update-clients-data`, {
//     method: "POST",
//     headers: {
//       ...headers,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ data }),
//   });

// export const startNewDay = (data) =>
//   fetch(`${API_URL}/start-new-day`, {
//     method: "POST",
//     headers: {
//       ...headers,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ data }),
//   });
  
// export const getAllData = () => 
//   fetch(`${API_URL}/get-all-data`, { headers })
//   .then((res) => res.json())
//   .then((data) => data);

// export const setAllData = (data) => 
//   fetch(`${API_URL}/set-all-data`, {
//     method: "POST",
//     headers: {
//       ...headers,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ data }),
//   });
